// extracted by mini-css-extract-plugin
export default {"buttons":"SystemTags_buttons__sc2AB","newTag":"SystemTags_newTag__6Li8h","search":"SystemTags_search__k1R1k"};